import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MeetingsService } from '../meetings.service';

@Component({
  selector: 'app-meeting-detail-dialog',
  templateUrl: './meeting-detail-dialog.component.html',
  styleUrls: ['./meeting-detail-dialog.component.scss']
})
export class MeetingDetailDialogComponent {
  saving = false;
  editingAttendees = false;
  attendeeStaffIds: number[] = [];
  loadingChat = false;

  constructor(
    private meetingsService: MeetingsService,
    private router: Router,
    public dialogRef: MatDialogRef<MeetingDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { meeting: any; staffOptions: any[] }
  ) {
    this.syncAttendees();
    this.loadChat();
  }

  toggleAttendeeEdit(): void {
    if (!this.data.meeting?.isOrganizer) return;
    this.syncAttendees();
    this.editingAttendees = !this.editingAttendees;
  }

  saveAttendees(): void {
    if (!this.data.meeting?.isOrganizer || !this.attendeeStaffIds.length) {
      Swal.fire('Required', 'Select at least one staff attendee.', 'info');
      return;
    }

    this.saving = true;
    this.meetingsService.update(this.data.meeting.id, { attendeeStaffIds: this.attendeeStaffIds }).subscribe({
      next: (meeting) => {
        this.saving = false;
        this.editingAttendees = false;
        this.data.meeting = meeting;
        this.syncAttendees();
      },
      error: (err) => {
        this.saving = false;
        Swal.fire('Error', err?.error?.message || 'Failed to update attendees.', 'error');
      }
    });
  }

  markStatus(status: 'Scheduled' | 'Completed' | 'Cancelled'): void {
    if (!this.data.meeting?.isOrganizer) return;

    this.saving = true;
    this.meetingsService.update(this.data.meeting.id, { status }).subscribe({
      next: (meeting) => {
        this.saving = false;
        this.data.meeting = meeting;
      },
      error: (err) => {
        this.saving = false;
        Swal.fire('Error', err?.error?.message || 'Failed to update meeting.', 'error');
      }
    });
  }

  copyRoomCode(): void {
    navigator.clipboard?.writeText(this.data.meeting?.roomCode || '');
  }

  openLiveRoom(): void {
    const meetingId = this.data.meeting?.id;
    if (!meetingId) return;
    this.dialogRef.close();
    this.router.navigateByUrl(`/meetings/${meetingId}/room`);
  }

  private syncAttendees(): void {
    this.attendeeStaffIds = (this.data.meeting?.attendees || [])
      .map((attendee: any) => attendee.staffId)
      .filter((staffId: any) => !!staffId);
  }

  private loadChat(): void {
    if (!this.data.meeting?.id) return;

    this.loadingChat = true;
    this.meetingsService.getChat(this.data.meeting.id).subscribe({
      next: (messages) => {
        this.loadingChat = false;
        this.data.meeting.chatMessages = messages || [];
      },
      error: () => {
        this.loadingChat = false;
        this.data.meeting.chatMessages = this.data.meeting.chatMessages || [];
      }
    });
  }
}
